import { UNIT_SYSTEM } from '../../../../shared/config/hydraulics_constants';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const columns = (renderNameCell, renderValueCell, renderActions, units, currentUnit) => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderNameCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'low_emw',
    headerName: `Low EMW (${units?.low_emw?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(units?.low_emw?.decimals));
    },
  },
  {
    field: 'high_emw',
    headerName: `High EMW (${units?.high_emw?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(units?.high_emw?.decimals));
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  }
];
export default columns;
